import { useLocation, useParams } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { locale } from 'modules/marketplace/components/utils/locales'
import Content from 'modules/marketplace_modules/components/Content'
import ModulesDetailRevamp from 'modules/marketplace_modules/pages/ModulesDetailRevamp'

import { countryCode } from '../components/utils/countryCode'
import { isModuleRevampEnabled } from '../components/utils/isModuleRevampEnabled'
import { useGetDatoModules } from '../hooks/useGetDatoModules'

const ModulesDetailTemplate = () => {
  const { id: slug } = useParams()
  const { pathname } = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const {
    company,
    access: { locale: user_locale },
  } = useCurrentSession()

  const datoFormatLocale = locale[user_locale]
  const countryCodeForCompany = countryCode(company.legalEntities[0]?.country || '')

  const { data: moduleData, loading } = useGetDatoModules({
    locale: datoFormatLocale,
    slug: slug,
    countryCode: countryCodeForCompany,
  })
  const module = moduleData.at(0)

  useEffect(() => {
    if (module) {
      track(trackingEvents.marketplaceModules.visitModuleDetailPage, {
        module_slug: slug,
        from: queryParams.get('from') || pathname,
        upsell_origin: queryParams.get('upsell_origin'),
      })
    }
  }, [])

  if (loading) return <Loading />

  if (!module) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  if (isModuleRevampEnabled(module.chargebeeModuleName || '')) {
    return <ModulesDetailRevamp />
  }

  return (
    <ResponsivePage.Body>
      <Content module={module} />
    </ResponsivePage.Body>
  )
}

export default ModulesDetailTemplate
